import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RescheduleItem } from "../../../domain/entities/reschedule";
import { type ReschedulesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listQueue = createAsyncThunk<
  RescheduleItem[],
  string,
  { dispatch: ReschedulesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_QUEUE, async (supervisorId, { extra }) => {
  return await extra.reschedulesRepo.listQueue(supervisorId);
});
